// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { boxShadows, transitions, breakpoints, functions } = theme;
  const { miniSidenav } = ownerState;

  const sidebarWidth = 250;
  const { xxl } = boxShadows;
  const { pxToRem } = functions;

  // Color de fondo del Sidenav
  let backgroundValue = "#1976d2"; // Azul sólido

  // Estilos cuando el sidenav está abierto
  const drawerOpenStyles = () => ({
    background: backgroundValue,
    color: "#fff",
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: xxl,
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // Estilos cuando el sidenav está colapsado
  const drawerCloseStyles = () => ({
    background: backgroundValue,
    color: "#fff",
    transform: `translateX(${pxToRem(-320)})`,
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("xl")]: {
      boxShadow: xxl,
      left: "0",
      width: pxToRem(96),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      boxShadow: xxl,
      border: "none",
      zIndex: 1000, // ✅ Evita que se sobreponga a otras ventanas
      position: "absolute", // ✅ Asegura que no cubra modales
      backdropFilter: "none", // ✅ Permite interacción con otros elementos
      pointerEvents: "auto", // ✅ Evita bloqueo de clics
      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
